module.exports = __webpack_public_path__ + "img/w8-b1.5aa5d9b2.jpg";